function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleads = function SvgGoogleads(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg_icon_googleads__Layer_1",
    width: "1em",
    height: "1em",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "svg_icon_googleads__g1",
    transform: "matrix(.09594 0 0 .09594 -.035 .13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_googleads__path1",
    d: "M85.643 38.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54 17.2 29.9 34.6 59.8 51.6 89.8 14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21-15.1-26.3-30.3-52.6-45.4-78.8-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9-6.7-11.8-13.6-23.5-20.3-35.2-4.3-7.6-8.8-15.1-13.1-22.7-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6",
    style: {
      fill: "#3c8bd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_googleads__path2",
    d: "M85.643 38.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5 11 18.9 22 37.9 32.9 56.9 1 1.7 1.8 3.4 2.8 5-6 10.4-12 20.7-18.1 31.1-8.4 14.5-16.8 29.1-25.3 43.6-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5 4.8-8.3 9.5-16.6 14.3-24.9 19.8-34.4 39.6-68.8 59.5-103.1.2-.4.5-.7.7-1.1",
    style: {
      fill: "#fabc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_icon_googleads__path3",
    d: "M11.543 168c1.9-1.7 3.7-3.5 5.7-5.1 24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9-19.7-1.4-35.2-16.2-37.9-35.8-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2",
    style: {
      fill: "#34a852"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleads);
export { ForwardRef as ReactComponent };